import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, notification, Divider } from 'antd';

const backend_url = process.env.REACT_APP_BACKEND_URL


const { Option } = Select;

function AddStation() {
  const [mainStation, setMainStation] = useState('');
  const [subStation, setSubStation] = useState('');
  const [stations, setStations] = useState([]);
  const [selectedStations, setSelectedStations] = useState('');

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const response = await axios.get(`${backend_url}/stations`);
        setStations(response.data);
      } catch (error) {
        console.error('Error fetching stations', error);
      }
    };

    fetchStations();
  }, []);

  const handleAddMainStation = async (values) => {




    try {
      // Check if the station already exists
      // const response = await axios.get(`http://localhost:${backendPort}/stations`);
      const response = await axios.get(`${backend_url}/stations`);
      const existingStations = response.data;
      // console.log(existingStations)
      const stationExists = existingStations.some(station => station.mainStation === values.mainStation);

      if (stationExists) {
        notification.error({ message: 'Station already exists' });
        return;
      }
      // console.log(values.mainStation)
      // Add the new station
      await axios.post(`${backend_url}/addmainStation`, { mainStation: values.mainStation });
      notification.success({ message: 'Main station added successfully' });
      setMainStation('');

      // Refresh stations
      const refreshedStationsResponse = await axios.get(`${backend_url}/stations`);
      setStations(refreshedStationsResponse.data);
    } catch (error) {
      console.error('Error adding main station', error);
      notification.error({ message: 'Failed to add main station' });
    }


  };

  const handleAddSubStation = async (values) => {
    try {
      // Fetch existing sub-stations for the selected main station
      // const response = await axios.get(`${backend_url}/stations`);
      const response = await axios.get(`${backend_url}/stations`);
      const existingStations = response.data;

      const selectedStation = existingStations.find(station => station.mainStation === values.selectedStation);

      if (selectedStation) {
        const subStations = selectedStation.subStations || [];
        const subStationExists = subStations.some(sub => sub === values.subStation);

        if (subStationExists) {
          notification.error({ message: 'Sub-station already exists' });
          return;
        }
      }

      // Add the new sub-station
      await axios.post(`${backend_url}/addsubStation`, {
        mainStation: values.selectedStation,
        subStation: values.subStation
      });

      notification.success({ message: 'Sub-station added successfully' });
      setSubStation('');

    } catch (error) {
      console.error('Error adding sub-station', error);
      notification.error({ message: 'Failed to add sub-station' });
    }
  }






  const { Option } = Select;





  return (



    <>
      <div className="p-4 sm:p-6 md:p-8 max-w-full md:max-w-4xl mx-auto h-auto mt-4 sm:mt-8 bg-white shadow-xl rounded-lg">
        <p className="bg-gray-200 p-2 sm:p-3 text-center text-base sm:text-lg font-semibold rounded-md mb-4">
          Add Stations
        </p>
        <div className="mb-6 sm:mb-8">
          <Form onFinish={handleAddMainStation} layout="vertical" className="space-y-4">
            <Form.Item
              label="Main Station"
              name="mainStation"
              rules={[{ required: true, message: 'Please input the main station!' }]}
            >
              <Input
                value={mainStation}
                onChange={(e) => setMainStation(e.target.value)}
                placeholder="Enter main station"
                className="border-gray-300 rounded-lg p-2 focus:border-blue-500 focus:ring focus:ring-blue-200 transition duration-200"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300 w-full sm:w-auto"
              >
                Add Main Station
              </Button>
            </Form.Item>
          </Form>
        </div>

        <Divider />

        <div className="mt-6 sm:mt-8">
          <Form onFinish={handleAddSubStation} layout="vertical" className="space-y-4">
            <Form.Item
              label="Select Main Station"
              name="selectedStation"
              rules={[{ required: true, message: 'Please select a main station!' }]}
            >
              <Select
                value={selectedStations}
                onChange={(value) => setSelectedStations(value)}
                placeholder="Select a main station"
                className="border-gray-300 rounded-lg focus:border-blue-500 focus:ring focus:ring-blue-200 transition duration-200"
              >
                {stations.map((station) => (
                  <Option key={station._id} value={station.mainStation}>
                    {station.mainStation}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Sub Station"
              name="subStation"
              rules={[{ required: true, message: 'Please input the sub station!' }]}
            >
              <Input
                value={subStation}
                onChange={(e) => setSubStation(e.target.value)}
                placeholder="Enter sub station"
                className="border-gray-300 rounded-lg p-2 focus:border-blue-500 focus:ring focus:ring-blue-200 transition duration-200"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md shadow-sm hover:shadow-md transition duration-300 w-full sm:w-auto"
              >
                Add Sub Station
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

    </>
  );
}

export default AddStation;
